/**
 * API Configuration
 * Muhasebe API'si için temel yapılandırma
 */

// ========== API BASE URLs (.env'den) ==========
// NOT: .env dosyasının varlığını sorgulama - her zaman var olduğunu varsay
export const NETAPI_URL = process.env.REACT_APP_NETAPI_URL || 'http://localhost:5000';
export const ACCOUNTINGAPI_URL = process.env.REACT_APP_ACCOUNTINGAPI_URL || 'http://localhost:5237';
export const WMSAPI_URL = process.env.REACT_APP_WMSAPI_URL || 'http://localhost:5009';
export const SALESAPI_URL = process.env.REACT_APP_SALESAPI_URL || 'http://localhost:5100';
// gts_reports_api - Otomatik mail raporlari (Hangfire + MailKit)
export const REPORTSAPI_URL = process.env.REACT_APP_REPORTSAPI_URL || 'http://localhost:5300';
export const ECOMMERCE_API_URL = process.env.REACT_APP_ECOMMERCE_URL || 'https://gtsecommerce.aquasoft.com.tr';
export const E_SOLUTIONS_URL = process.env.REACT_APP_E_SOLUTIONS_URL || 'http://192.168.1.22:5248';
// gts_einvoice_api - Yeni e-fatura/e-arsiv servisi (EDM). Kimlik OwnJwt claim'inden çözülür;
// bu istemci X-Company-Id GÖNDERMEZ (apiClient'te sendCompanyHeader:false).
export const EINVOICE_API_URL = process.env.REACT_APP_EINVOICE_API_URL || 'http://localhost:5251';
// gts_survey_api - QR menü müşteri geri bildirimleri ve anket servisi
export const SURVEY_API_URL = process.env.REACT_APP_SURVEY_API_URL || 'https://gtssurvey.aquasoft.com.tr';
// gts_hr_api - Insan Kaynaklari (personel/yetki/departman/vardiya/attendance)
export const HRAPI_URL = process.env.REACT_APP_HRAPI_URL || 'http://localhost:5302';
// gts_task_api - Gorev Takip (tekil/tekrarli/ekip/yillik gorevler + tamamlama/kacirma)
export const TASKAPI_URL = process.env.REACT_APP_TASKAPI_URL || 'http://localhost:5304';
// gts_ai_api - AI Asistan servisi (AI chat + ajan modu + public asistan + AI rapor onerisi).
// Tum Gemini cagrilari bu API'de toplanir (gts_sales_api'den tasindi - Temmuz 2026).
export const AIAPI_URL = process.env.REACT_APP_AIAPI_URL || 'http://localhost:5290';

// Legacy - geriye dönük uyumluluk için
export const API_BASE_URL = ACCOUNTINGAPI_URL;
export const WMS_BASE_URL = WMSAPI_URL;

// Accounting API Endpoints
export const ACCOUNTING_API = {
  // Account Group Endpoints
  ACCOUNT_GROUPS: `${API_BASE_URL}/api/AccountGroup`,
  ACCOUNT_GROUP_BY_ID: (id: number) => `${API_BASE_URL}/api/AccountGroup/${id}`,
  ACCOUNT_GROUP_BY_COMPANY: `${API_BASE_URL}/api/AccountGroup`,
  ACCOUNT_GROUP_UPDATE: (id: number) => `${API_BASE_URL}/api/AccountGroup/${id}/update`,
  ACCOUNT_GROUP_DELETE: (id: number) => `${API_BASE_URL}/api/AccountGroup/${id}/delete`,
  ACCOUNT_GROUP_CHILDREN: (parentId: number) => `${API_BASE_URL}/api/AccountGroup/${parentId}/children`,
  
  // Account Endpoints
  ACCOUNTS: `${API_BASE_URL}/api/Account`,
  ACCOUNT_BY_ID: (id: number) => `${API_BASE_URL}/api/Account/${id}`,
  ACCOUNT_FIND_OR_CREATE_BY_TAX: `${API_BASE_URL}/api/Account/find-or-create-by-tax`,
  ACCOUNT_BY_COMPANY: `${API_BASE_URL}/api/Account`,
  ACCOUNT_BY_COMPANY_PAGED: (page: number, pageSize: number, searchTerm?: string, groupId?: number, sortColumn?: string, sortDirection?: string, isActive?: boolean, branchId?: string | null) => {
    const params = new URLSearchParams({ page: page.toString(), pageSize: pageSize.toString() });
    if (searchTerm) params.append('searchTerm', searchTerm);
    if (groupId) params.append('groupId', groupId.toString());
    if (sortColumn) params.append('sortColumn', sortColumn);
    if (sortDirection) params.append('sortDirection', sortDirection);
    if (isActive !== undefined) params.append('isActive', isActive.toString());
    if (branchId) params.append('branchId', branchId);
    return `${API_BASE_URL}/api/Account/paged?${params.toString()}`;
  },
  ACCOUNT_RECENTLY_TRANSACTED: (limit: number = 11, branchId?: string | null) => {
    let url = `${API_BASE_URL}/api/Account/recently-transacted?limit=${limit}`;
    if (branchId) url += `&branchId=${branchId}`;
    return url;
  }, // En son işlem yapılan cariler (SQL'de join, opsiyonel şube filtresi)
  ACCOUNT_BY_CODE: (accountCode: string) => `${API_BASE_URL}/api/Account/code/${accountCode}`,
  ACCOUNT_UPDATE: (id: number) => `${API_BASE_URL}/api/Account/${id}/update`,
  ACCOUNT_DELETE: (id: number) => `${API_BASE_URL}/api/Account/${id}/delete`,
  ACCOUNT_ACTIVATE: (id: number) => `${API_BASE_URL}/api/Account/${id}/activate`,
  ACCOUNT_DEACTIVATE: (id: number) => `${API_BASE_URL}/api/Account/${id}/deactivate`,
  ACCOUNT_GENERATE_CODE: `${API_BASE_URL}/api/Account/generate-code`,
  ACCOUNT_RECALCULATE_BALANCES: `${API_BASE_URL}/api/Account/recalculate-balances`,
  
  // Shipping Address Endpoints
  SHIPPING_ADDRESSES: (accountId: number) => `${API_BASE_URL}/api/Account/${accountId}/shipping-addresses`,
  SHIPPING_ADDRESS_UPDATE: (accountId: number, addressId: number) => `${API_BASE_URL}/api/Account/${accountId}/shipping-addresses/${addressId}/update`,
  SHIPPING_ADDRESS_DELETE: (accountId: number, addressId: number) => `${API_BASE_URL}/api/Account/${accountId}/shipping-addresses/${addressId}/delete`,
  
  // Account Transaction Endpoints
  TRANSACTIONS: `${API_BASE_URL}/api/AccountTransaction`,
  TRANSACTION_BY_ID: (id: number) => `${API_BASE_URL}/api/AccountTransaction/${id}`,
  TRANSACTIONS_BY_ACCOUNT: (accountId: number) => `${API_BASE_URL}/api/AccountTransaction/account/${accountId}`,
  ACCOUNT_STATEMENT: (accountId: number) => `${API_BASE_URL}/api/AccountTransaction/account/${accountId}/statement`,
  TRANSACTIONS_BY_ACCOUNT_PAGED: (accountId: number, page: number = 1, pageSize: number = 50, options?: { sortColumn?: string; sortDirection?: string; startDate?: string; endDate?: string; transactionType?: string; searchTerm?: string; branchId?: string | null }) => {
    const params = new URLSearchParams({
      accountId: accountId.toString(),
      page: page.toString(),
      pageSize: pageSize.toString(),
    });
    if (options?.sortColumn) params.append('sortColumn', options.sortColumn);
    if (options?.sortDirection) params.append('sortDirection', options.sortDirection);
    if (options?.startDate) params.append('startDate', options.startDate);
    if (options?.endDate) params.append('endDate', options.endDate);
    if (options?.transactionType) params.append('transactionType', options.transactionType);
    if (options?.searchTerm) params.append('searchTerm', options.searchTerm);
    if (options?.branchId) params.append('branchId', options.branchId);
    return `${API_BASE_URL}/api/AccountTransaction/paged?${params.toString()}`;
  },
  TRANSACTIONS_BY_COMPANY: `${API_BASE_URL}/api/AccountTransaction`,
  TRANSACTION_CHANGE_PAYMENT_METHOD: (id: number) => `${API_BASE_URL}/api/AccountTransaction/${id}/change-payment-method`,
  TRANSACTION_DELETE: (id: number) => `${API_BASE_URL}/api/AccountTransaction/${id}/delete`,
  TRANSACTION_COLLECTION: `${API_BASE_URL}/api/AccountTransaction/collection`,
  TRANSACTION_PAYMENT: `${API_BASE_URL}/api/AccountTransaction/payment`,
  TRANSACTION_DEBIT: `${API_BASE_URL}/api/AccountTransaction/debit`,
  TRANSACTION_INVOICE: `${API_BASE_URL}/api/AccountTransaction/invoice`,
  
  // Transaction Log Endpoints
  TRANSACTION_LOGS_BY_COMPANY: `${API_BASE_URL}/api/AccountTransaction/logs/company`,
  TRANSACTION_LOGS_BY_TRANSACTION: (transactionId: number) => `${API_BASE_URL}/api/AccountTransaction/logs/transaction/${transactionId}`,
  
  // Offsetting Transaction Endpoints
  OFFSETTING: `${API_BASE_URL}/api/OffsettingTransaction`,
  OFFSETTING_BY_ID: (id: number) => `${API_BASE_URL}/api/OffsettingTransaction/${id}`,
  OFFSETTING_BY_COMPANY: `${API_BASE_URL}/api/OffsettingTransaction`,
  OFFSETTING_DELETE: (id: number) => `${API_BASE_URL}/api/OffsettingTransaction/${id}/delete`,
  
  // Cashbox Endpoints
  CASHBOXES: `${API_BASE_URL}/api/Cashbox`,
  CASHBOX_BY_ID: (id: number) => `${API_BASE_URL}/api/Cashbox/${id}`,
  CASHBOX_BY_COMPANY: `${API_BASE_URL}/api/Cashbox`,
  CASHBOX_DASHBOARD: (branchId?: string | null) => {
    let url = `${API_BASE_URL}/api/Cashbox/dashboard`;
    if (branchId) url += `?branchId=${branchId}`;
    return url;
  },
  CASHBOX_UPDATE: (id: number) => `${API_BASE_URL}/api/Cashbox/${id}/update`,
  CASHBOX_DELETE: (id: number) => `${API_BASE_URL}/api/Cashbox/${id}/delete`,
  CASHBOX_DEPOSIT: (id: number) => `${API_BASE_URL}/api/Cashbox/${id}/deposit`,
  CASHBOX_WITHDRAW: (id: number) => `${API_BASE_URL}/api/Cashbox/${id}/withdraw`,
  CASHBOX_TRANSACTIONS: (id: number) => `${API_BASE_URL}/api/Cashbox/${id}/transactions`,
  CASHBOX_COMPANY_TRANSACTIONS: `${API_BASE_URL}/api/Cashbox/transactions`,
  CASHBOX_COMPANY_TRANSACTIONS_PAGED: (params: {
    page: number; pageSize: number; searchTerm?: string;
    sortColumn?: string; sortDirection?: string;
    cashboxId?: string; type?: string;
    startDate?: string; endDate?: string;
    branchIds?: string;
  }) => {
    const p = new URLSearchParams();
    p.append('page', params.page.toString());
    p.append('pageSize', params.pageSize.toString());
    if (params.searchTerm) p.append('searchTerm', params.searchTerm);
    if (params.sortColumn) p.append('sortColumn', params.sortColumn);
    if (params.sortDirection) p.append('sortDirection', params.sortDirection);
    if (params.cashboxId) p.append('cashboxId', params.cashboxId);
    if (params.type) p.append('type', params.type);
    if (params.startDate) p.append('startDate', params.startDate);
    if (params.endDate) p.append('endDate', params.endDate);
    if (params.branchIds) p.append('branchIds', params.branchIds);
    return `${API_BASE_URL}/api/Cashbox/transactions/paged?${p.toString()}`;
  },
  CASHBOX_DAILY_SUMMARY: `${API_BASE_URL}/api/Cashbox/daily-summary`, // Kasa özet hesaplaması (devreden bakiye, bugün, net bakiye)
  CASHBOX_ALL_BALANCES: `${API_BASE_URL}/api/Cashbox/balances`, // Tüm kasaların güncel bakiyelerini hesapla (işlem kayıtlarından)
  CASHBOX_TRANSFER: `${API_BASE_URL}/api/Cashbox/transfer`, // Kasadan kasaya transfer
  CASHBOX_BANK_TRANSFER: `${API_BASE_URL}/api/BankAccount/transfer-from-cash`, // Kasadan bankaya transfer (alias)
  CASHBOX_TRANSACTION_DELETE: (id: number) => `${API_BASE_URL}/api/Cashbox/transaction/${id}/delete`, // Kasa işlemi silme (Hard Delete + Log)
  CASHBOX_TRANSACTION_LOGS_BY_COMPANY: `${API_BASE_URL}/api/Cashbox/logs/company`, // Şirket bazında log kayıtları (backend route: logs/company)
  CASHBOX_TRANSACTION_LOGS_BY_TRANSACTION: (transactionId: number) => `${API_BASE_URL}/api/Cashbox/logs/transaction/${transactionId}`, // İşleme ait log kayıtları
  
  // Personnel Transaction Endpoints (personel borc/alacak/maas — SQL taşıma)
  PERSONNEL_TX_BY_PERSONNEL: (firebaseUid: string, page: number = 1, pageSize: number = 50) =>
    `${API_BASE_URL}/api/PersonnelTransaction/personnel/${encodeURIComponent(firebaseUid)}?page=${page}&pageSize=${pageSize}`,
  PERSONNEL_TX_BALANCE: (firebaseUid: string) =>
    `${API_BASE_URL}/api/PersonnelTransaction/personnel/${encodeURIComponent(firebaseUid)}/balance`,
  PERSONNEL_TX_ALL_BALANCES: `${API_BASE_URL}/api/PersonnelTransaction/balances`, // Şirket geneli tüm personel bakiyeleri (tek istek)
  PERSONNEL_TX_ACCRUALS: (firebaseUid: string, kind?: string, unpaidOnly: boolean = true) => {
    const p = new URLSearchParams({ unpaidOnly: unpaidOnly.toString() });
    if (kind) p.append('kind', kind);
    return `${API_BASE_URL}/api/PersonnelTransaction/personnel/${encodeURIComponent(firebaseUid)}/accruals?${p.toString()}`;
  },
  PERSONNEL_TX_CREATE: `${API_BASE_URL}/api/PersonnelTransaction/create`,
  PERSONNEL_TX_CREATE_ACCRUAL: `${API_BASE_URL}/api/PersonnelTransaction/create-accrual`,
  PERSONNEL_TX_MARK_PAID: `${API_BASE_URL}/api/PersonnelTransaction/mark-paid`,
  PERSONNEL_TX_DELETE: `${API_BASE_URL}/api/PersonnelTransaction/delete`,

  // Bank Account Endpoints
  BANK_ACCOUNTS: `${API_BASE_URL}/api/BankAccount`,
  BANK_ACCOUNT_BY_ID: (id: number) => `${API_BASE_URL}/api/BankAccount/${id}`,
  BANK_ACCOUNT_BY_COMPANY: `${API_BASE_URL}/api/BankAccount`,
  BANK_ACCOUNT_DASHBOARD: (branchId?: string | null) => {
    let url = `${API_BASE_URL}/api/BankAccount/dashboard`;
    if (branchId) url += `?branchId=${branchId}`;
    return url;
  },
  BANK_ACCOUNT_UPDATE: (id: number) => `${API_BASE_URL}/api/BankAccount/${id}/update`,
  BANK_ACCOUNT_DELETE: (id: number) => `${API_BASE_URL}/api/BankAccount/${id}/delete`,
  BANK_ACCOUNT_DEPOSIT: (id: number) => `${API_BASE_URL}/api/BankAccount/${id}/deposit`,
  BANK_ACCOUNT_WITHDRAW: (id: number) => `${API_BASE_URL}/api/BankAccount/${id}/withdraw`,
  BANK_ACCOUNT_TRANSACTIONS: (id: number) => `${API_BASE_URL}/api/BankAccount/${id}/transactions`,
  BANK_ACCOUNT_COMPANY_TRANSACTIONS: `${API_BASE_URL}/api/BankAccount/transactions`,
  BANK_ACCOUNT_COMPANY_TRANSACTIONS_PAGED: (params: { page: number; pageSize: number; searchTerm?: string; sortColumn?: string; sortDirection?: string; bankAccountId?: number; transactionType?: string; startDate?: string; endDate?: string; screenIds?: string }) => {
    const p = new URLSearchParams();
    p.append('page', params.page.toString());
    p.append('pageSize', params.pageSize.toString());
    if (params.searchTerm) p.append('searchTerm', params.searchTerm);
    if (params.sortColumn) p.append('sortColumn', params.sortColumn);
    if (params.sortDirection) p.append('sortDirection', params.sortDirection);
    if (params.bankAccountId) p.append('bankAccountId', params.bankAccountId.toString());
    if (params.transactionType) p.append('transactionType', params.transactionType);
    if (params.startDate) p.append('startDate', params.startDate);
    if (params.endDate) p.append('endDate', params.endDate);
    if (params.screenIds) p.append('screenIds', params.screenIds);
    return `${API_BASE_URL}/api/BankAccount/transactions/paged?${p.toString()}`;
  },
  BANK_ACCOUNT_VIRMAN: `${API_BASE_URL}/api/BankAccount/virman`, // Banka içi virman (alt hesap arası)
  BANK_ACCOUNT_TRANSFER: `${API_BASE_URL}/api/BankAccount/transfer`, // Bankadan bankaya transfer
  BANK_ACCOUNT_TRANSFER_TO_CASH: `${API_BASE_URL}/api/BankAccount/transfer-to-cash`, // Bankadan kasaya transfer
  BANK_ACCOUNT_TRANSFER_FROM_CASH: `${API_BASE_URL}/api/BankAccount/transfer-from-cash`, // Kasadan bankaya transfer
  
  BANK_SUMMARY: `${API_BASE_URL}/api/BankAccount/summary`, // Banka dashboard özeti (bugünkü giriş/çıkış, bekleyen tahsilat/ödeme)

  // Bank Transaction Endpoints (Banka Hareketleri)
  BANK_TRANSACTIONS_BY_COMPANY: `${API_BASE_URL}/api/BankAccount/transactions`, // Tüm banka hareketleri
  BANK_TRANSACTION_DELETE: (id: number) => `${API_BASE_URL}/api/BankAccount/transaction/${id}/delete`, // Banka işlemi silme (Hard Delete + Log)
  BANK_TRANSACTION_LOGS_BY_COMPANY: `${API_BASE_URL}/api/BankAccount/logs/company`, // Şirket bazında log kayıtları (backend route: logs/company)
  BANK_TRANSACTION_LOGS_BY_TRANSACTION: (transactionId: number) => `${API_BASE_URL}/api/BankAccount/logs/transaction/${transactionId}`, // İşleme ait log kayıtları
  
  // Bank Sub Account Endpoints
  BANK_SUB_ACCOUNT: `${API_BASE_URL}/api/BankAccount/sub-account`,
  BANK_SUB_ACCOUNT_UPDATE: (id: number) => `${API_BASE_URL}/api/BankAccount/sub-account/${id}/update`,
  BANK_SUB_ACCOUNT_DELETE: (id: number) => `${API_BASE_URL}/api/BankAccount/sub-account/${id}/delete`,
  BANK_SUB_ACCOUNT_TRANSACTIONS: (id: number) => `${API_BASE_URL}/api/BankAccount/sub-account/${id}/transactions`,
  
  // Credit Card Endpoints (Kredi Kartı Yönetimi)
  CREDIT_CARDS: `${API_BASE_URL}/api/CreditCard`,
  CREDIT_CARD_BY_ID: (id: number) => `${API_BASE_URL}/api/CreditCard/${id}`,
  CREDIT_CARD_BY_COMPANY: `${API_BASE_URL}/api/CreditCard`,
  CREDIT_CARD_BY_BANK: (bankAccountId: number) => `${API_BASE_URL}/api/CreditCard/bank/${bankAccountId}`,
  CREDIT_CARD_BY_BRANCH: (branchId: string) => `${API_BASE_URL}/api/CreditCard/branch/${branchId}`,
  CREDIT_CARD_UPDATE: (id: number) => `${API_BASE_URL}/api/CreditCard/${id}/update`,
  CREDIT_CARD_DELETE: (id: number) => `${API_BASE_URL}/api/CreditCard/${id}/delete`,
  CREDIT_CARD_ADD_USAGE: (id: number) => `${API_BASE_URL}/api/CreditCard/${id}/add-usage`,
  
  // CheckBook Endpoints (Çek Defteri Yönetimi)
  CHECK_BOOKS: `${API_BASE_URL}/api/CheckBook`,
  CHECK_BOOK_BY_ID: (id: number) => `${API_BASE_URL}/api/CheckBook/${id}`,
  CHECK_BOOK_BY_COMPANY: `${API_BASE_URL}/api/CheckBook`,
  CHECK_BOOK_BY_COMPANY_ACTIVE: `${API_BASE_URL}/api/CheckBook/active`,
  CHECK_BOOK_BY_BANK_ACCOUNT: (bankAccountId: number) => `${API_BASE_URL}/api/CheckBook/bankaccount/${bankAccountId}`,
  CHECK_BOOK_BY_BANK_ACCOUNT_AVAILABLE: (bankAccountId: number) => `${API_BASE_URL}/api/CheckBook/bankaccount/${bankAccountId}/available`,
  CHECK_BOOK_SUMMARY: `${API_BASE_URL}/api/CheckBook/summary`,
  CHECK_BOOK_UPDATE: (id: number) => `${API_BASE_URL}/api/CheckBook/${id}/update`,
  CHECK_BOOK_DELETE: (id: number) => `${API_BASE_URL}/api/CheckBook/${id}/delete`,
  CHECK_BOOK_USE_NEXT_NUMBER: (id: number) => `${API_BASE_URL}/api/CheckBook/${id}/use-next-number`,
  CHECK_BOOK_IS_NUMBER_USED: (id: number, checkNumber: number) => `${API_BASE_URL}/api/CheckBook/${id}/check-number/${checkNumber}/is-used`,
  CREDIT_CARD_PAYMENT: (id: number) => `${API_BASE_URL}/api/CreditCard/${id}/payment`,
  CREDIT_CARD_TRANSACTIONS: (id: number, params?: { page?: number; pageSize?: number }) => {
    let url = `${API_BASE_URL}/api/CreditCard/${id}/transactions`;
    const qp = new URLSearchParams();
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  CREDIT_CARD_TRANSACTION_DELETE: (id: number, transactionId: number) => `${API_BASE_URL}/api/CreditCard/${id}/transactions/${transactionId}/delete`, // Kart hareketi sil (bakiye geri düzeltilir)
  CREDIT_CARD_NEAR_STATEMENT_DAY: `${API_BASE_URL}/api/CreditCard/near-statement-day`,
  CREDIT_CARD_NEAR_DUE_DAY: `${API_BASE_URL}/api/CreditCard/near-due-day`,

  // Bank Loan Endpoints (Banka Kredi Yönetimi)
  BANK_LOANS: (params?: { page?: number; pageSize?: number; status?: string; search?: string }) => {
    let url = `${API_BASE_URL}/api/BankLoan`;
    const qp = new URLSearchParams();
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    if (params?.status) qp.append('status', params.status);
    if (params?.search) qp.append('search', params.search);
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  BANK_LOAN_CREATE: `${API_BASE_URL}/api/BankLoan`,
  BANK_LOAN_BY_ID: (id: number) => `${API_BASE_URL}/api/BankLoan/${id}`,
  BANK_LOAN_UPDATE: (id: number) => `${API_BASE_URL}/api/BankLoan/${id}/update`,
  BANK_LOAN_DELETE: (id: number) => `${API_BASE_URL}/api/BankLoan/${id}/delete`,
  BANK_LOAN_INSTALLMENT_PAY: (installmentId: number) => `${API_BASE_URL}/api/BankLoan/installment/${installmentId}/pay`,
  // Ödeme geri alma ayrı endpoint DEĞİLDİR — ödeme silme (hard delete) bu işlevi görür
  BANK_LOAN_PAYMENTS: (params?: { page?: number; pageSize?: number; loanId?: number; search?: string; dateFrom?: string; dateTo?: string }) => {
    let url = `${API_BASE_URL}/api/BankLoan/payments`;
    const qp = new URLSearchParams();
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    if (params?.loanId) qp.append('loanId', params.loanId.toString());
    if (params?.search) qp.append('search', params.search);
    if (params?.dateFrom) qp.append('dateFrom', params.dateFrom);
    if (params?.dateTo) qp.append('dateTo', params.dateTo);
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  BANK_LOAN_PAYMENT_DELETE: `${API_BASE_URL}/api/BankLoan/payment/delete`,
  BANK_LOAN_UPCOMING: (daysAhead?: number) => `${API_BASE_URL}/api/BankLoan/upcoming-installments?daysAhead=${daysAhead ?? 5}`,

  // Project Endpoints (Proje Yönetim Sistemi — PYS)
  PROJECT_LIST: (params?: { page?: number; pageSize?: number; search?: string; status?: string; includeSummary?: boolean }) => {
    let url = `${API_BASE_URL}/api/Project`;
    const qp = new URLSearchParams();
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    if (params?.search) qp.append('search', params.search);
    if (params?.status) qp.append('status', params.status);
    if (params?.includeSummary) qp.append('includeSummary', 'true');
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  PROJECT_BY_ID: (id: number) => `${API_BASE_URL}/api/Project/${id}`,
  PROJECT_CREATE: `${API_BASE_URL}/api/Project/create`,
  PROJECT_UPDATE: `${API_BASE_URL}/api/Project/update`,
  PROJECT_STATUS: `${API_BASE_URL}/api/Project/status`,
  PROJECT_DELETE: `${API_BASE_URL}/api/Project/delete`,
  PROJECT_SUMMARY: (id: number) => `${API_BASE_URL}/api/Project/${id}/summary`,
  PROJECT_TRANSACTIONS: (id: number, params?: { page?: number; pageSize?: number }) => {
    let url = `${API_BASE_URL}/api/Project/${id}/transactions`;
    const qp = new URLSearchParams();
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  
  // Account (Cari) Transfer Endpoint
  ACCOUNT_TRANSFER: `${API_BASE_URL}/api/Account/transfer`, // Cariden cariye transfer (Mahsup Fişi)
  
  // ========== INVENTORY ENDPOINTS ==========
  
  // Inventory Categories
  INVENTORY_CATEGORIES: `${API_BASE_URL}/api/Inventory/categories`,
  INVENTORY_CATEGORY_BY_ID: (id: string) => `${API_BASE_URL}/api/Inventory/categories/${id}`,
  INVENTORY_CATEGORY_CREATE: `${API_BASE_URL}/api/Inventory/categories`,
  INVENTORY_CATEGORY_UPDATE: (id: string) => `${API_BASE_URL}/api/Inventory/categories/${id}/update`, // POST kullanıyoruz
  INVENTORY_CATEGORY_DELETE: (id: string) => `${API_BASE_URL}/api/Inventory/categories/${id}/delete`, // POST kullanıyoruz
  INVENTORY_CATEGORY_TOGGLE_ECOMMERCE: (id: string, enable: boolean) => `${API_BASE_URL}/api/Inventory/categories/${id}/ecommerce/toggle?enable=${enable}`, // POST kullanıyoruz

  // Inventory Product Features
  INVENTORY_PRODUCT_FEATURES: `${API_BASE_URL}/api/Inventory/product-features`,
  INVENTORY_PRODUCT_FEATURE_BY_ID: (id: string) => `${API_BASE_URL}/api/Inventory/product-features/${id}`,
  INVENTORY_PRODUCT_FEATURE_CREATE: `${API_BASE_URL}/api/Inventory/product-features`,
  INVENTORY_PRODUCT_FEATURE_UPDATE: (id: string) => `${API_BASE_URL}/api/Inventory/product-features/${id}/update`,
  INVENTORY_PRODUCT_FEATURE_DELETE: (id: string) => `${API_BASE_URL}/api/Inventory/product-features/${id}/delete`,
  
  // Inventory Brands
  INVENTORY_BRANDS: `${API_BASE_URL}/api/Inventory/brands`,
  INVENTORY_BRAND_CREATE: `${API_BASE_URL}/api/Inventory/brands`,
  INVENTORY_BRAND_UPDATE: (id: string) => `${API_BASE_URL}/api/Inventory/brands/${id}/update`, // POST kullanıyoruz
  INVENTORY_BRAND_DELETE: (id: string) => `${API_BASE_URL}/api/Inventory/brands/${id}/delete`, // POST kullanıyoruz
  
  // Inventory Warehouses
  INVENTORY_WAREHOUSES: `${API_BASE_URL}/api/Inventory/warehouses`,
  INVENTORY_WAREHOUSE_CREATE: `${API_BASE_URL}/api/Inventory/warehouses`,
  INVENTORY_WAREHOUSE_UPDATE: (id: string) => `${API_BASE_URL}/api/Inventory/warehouses/${id}/update`, // POST kullanıyoruz
  INVENTORY_WAREHOUSE_DELETE: (id: string) => `${API_BASE_URL}/api/Inventory/warehouses/${id}/delete`, // POST kullanıyoruz
  INVENTORY_WAREHOUSE_TRANSFER: `${API_BASE_URL}/api/Inventory/warehouse/transfer`, // Depolar arası transfer
  INVENTORY_WAREHOUSE_TRANSFERS: `${API_BASE_URL}/api/Inventory/warehouse/transfers`, // Transfer fişleri listesi
  INVENTORY_WAREHOUSE_TRANSFERS_PAGED: `${API_BASE_URL}/api/Inventory/warehouse/transfers/paged`, // Sayfalı transfer fişleri
  INVENTORY_WAREHOUSE_TRANSFER_DETAIL: (transferId: string) => `${API_BASE_URL}/api/Inventory/warehouse/transfers/detail/${transferId}`, // Transfer detayı
  INVENTORY_WAREHOUSE_TRANSFER_REVERSE: (transferId: string) => `${API_BASE_URL}/api/Inventory/warehouse/transfers/${transferId}/reverse`, // Transfer geri alma
  INVENTORY_WAREHOUSE_TRANSFER_CREATE: `${API_BASE_URL}/api/Inventory/warehouse/transfer`, // Yeni transfer oluştur
  INVENTORY_WAREHOUSE_ADD_STOCK: `${API_BASE_URL}/api/Inventory/warehouse/add-stock`, // Depoya ürün ekle (transfer mantığı ile ama kaynak depo yok)
  INVENTORY_WAREHOUSE_STOCK_UPDATE: `${API_BASE_URL}/api/Inventory/warehouse-stock/update`,
  INVENTORY_STOCK_BY_LOCATION: (warehouseId: string) => `${API_BASE_URL}/api/Inventory/stock-by-location/${warehouseId}`,
  INVENTORY_PRODUCT_LOCATIONS: (productId: string, warehouseId: string) => `${API_BASE_URL}/api/Inventory/product-locations/${productId}/${warehouseId}`,

  // Stock Movements (Stok Hareketleri)
  STOCK_MOVEMENTS_BY_COMPANY: `${API_BASE_URL}/api/StockMovement`,
  STOCK_MOVEMENTS_BY_PRODUCT: (productId: string) => `${API_BASE_URL}/api/StockMovement/product/${productId}`,
  STOCK_MOVEMENTS_BY_WAREHOUSE: (warehouseId: string) => `${API_BASE_URL}/api/StockMovement/warehouse/${warehouseId}`,
  STOCK_MOVEMENTS_BY_DATE_RANGE: (startDate: string, endDate: string) => 
    `${API_BASE_URL}/api/StockMovement/date-range?startDate=${startDate}&endDate=${endDate}`,
  STOCK_MOVEMENT_CREATE_MANUAL: `${API_BASE_URL}/api/StockMovement/manual`, // Manuel stok hareketi oluştur
  STOCK_MOVEMENT_DELETE: `${API_BASE_URL}/api/StockMovement/delete`, // Stok hareketi sil (POST kullanılır, DELETE desteklenmiyor)
  STOCK_MOVEMENTS_PAGED: (params: {
    page?: number; pageSize?: number; search?: string;
    movementType?: string; direction?: string;
    startDate?: string; endDate?: string;
    branchId?: string; screenId?: string; categoryId?: string;
    productId?: string; warehouseId?: string;
    export?: boolean;
    sortColumn?: string; sortDirection?: string;
  }) => {
    let url = `${API_BASE_URL}/api/StockMovement/paged?page=${params.page || 1}&pageSize=${params.pageSize || 50}`;
    if (params.search) url += `&search=${encodeURIComponent(params.search)}`;
    if (params.movementType) url += `&movementType=${encodeURIComponent(params.movementType)}`;
    if (params.direction) url += `&direction=${encodeURIComponent(params.direction)}`;
    if (params.startDate) url += `&startDate=${encodeURIComponent(params.startDate)}`;
    if (params.endDate) url += `&endDate=${encodeURIComponent(params.endDate)}`;
    if (params.branchId) url += `&branchId=${encodeURIComponent(params.branchId)}`;
    if (params.screenId) url += `&screenId=${encodeURIComponent(params.screenId)}`;
    if (params.categoryId) url += `&categoryId=${encodeURIComponent(params.categoryId)}`;
    if (params.productId) url += `&productId=${encodeURIComponent(params.productId)}`;
    if (params.warehouseId) url += `&warehouseId=${encodeURIComponent(params.warehouseId)}`;
    if (params.export) url += `&export=true`;
    if (params.sortColumn) url += `&sortColumn=${encodeURIComponent(params.sortColumn)}`;
    if (params.sortDirection) url += `&sortDirection=${encodeURIComponent(params.sortDirection)}`;
    return url;
  }, // Server-side sayfalı stok hareketleri (Rule 9 uyumlu)
  STOCK_MOVEMENTS_TOP_SELLING: (limit: number = 11, startDate?: string, endDate?: string, branchId?: string | null) => {
    let url = `${API_BASE_URL}/api/Inventory/stock-movements/top-selling-products?limit=${limit}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (branchId) url += `&branchId=${branchId}`;
    return url;
  }, // En çok satan ürünler (SQL'de gruplama, tarih ve şube filtreleri ile)
  STOCK_MOVEMENTS_TOP_SELLING_PAGED: (page: number, pageSize: number, startDate?: string, endDate?: string, branchId?: string | null) => {
    let url = `${API_BASE_URL}/api/Inventory/stock-movements/top-selling-products/paged?page=${page}&pageSize=${pageSize}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (branchId) url += `&branchId=${branchId}`;
    return url;
  }, // En çok satan ürünler - server-side sayfalı detay listesi (Dashboard detay modalı)
  STOCK_MOVEMENTS_DAILY_SALES_SUMMARY: (startDate: string, endDate: string, branchId?: string | null) => {
    let url = `${API_BASE_URL}/api/Inventory/stock-movements/daily-sales-summary?startDate=${startDate}&endDate=${endDate}`;
    if (branchId) url += `&branchId=${branchId}`;
    return url;
  }, // Günlük satış özeti - şube bazlı (StockMovements'dan)
  INVENTORY_SUMMARY: (params?: {
    searchTerm?: string; categoryId?: string; brandId?: string;
    warehouseId?: string; isActive?: boolean; hideZeroPrice?: boolean;
    vatRate?: number; departmentNo?: number;
    // Gelişmiş filtreler (paged liste ile parity)
    isEcommerce?: boolean; branchId?: string; locationId?: string;
    minSalePrice?: number; maxSalePrice?: number;
    minQuantity?: number; maxQuantity?: number;
    createdFrom?: string; createdTo?: string;
    hideZeroStock?: boolean; hidePositiveStock?: boolean;
    categoryIds?: string[]; brandIds?: string[];
    onlyWithoutImage?: boolean;
  }) => {
    let url = `${API_BASE_URL}/api/Inventory/summary`;
    if (params) {
      const qp = new URLSearchParams();
      if (params.searchTerm) qp.append('searchTerm', params.searchTerm);
      if (params.categoryId) qp.append('categoryId', params.categoryId);
      if (params.brandId) qp.append('brandId', params.brandId);
      if (params.warehouseId) qp.append('warehouseId', params.warehouseId);
      if (params.isActive !== undefined) qp.append('isActive', String(params.isActive));
      if (params.hideZeroPrice !== undefined) qp.append('hideZeroPrice', String(params.hideZeroPrice));
      if (params.vatRate !== undefined) qp.append('vatRate', String(params.vatRate));
      if (params.departmentNo !== undefined) qp.append('departmentNo', String(params.departmentNo));
      if (params.isEcommerce !== undefined) qp.append('isEcommerce', String(params.isEcommerce));
      if (params.branchId) qp.append('branchId', params.branchId);
      if (params.locationId) qp.append('locationId', params.locationId);
      if (params.minSalePrice !== undefined) qp.append('minSalePrice', String(params.minSalePrice));
      if (params.maxSalePrice !== undefined) qp.append('maxSalePrice', String(params.maxSalePrice));
      if (params.minQuantity !== undefined) qp.append('minQuantity', String(params.minQuantity));
      if (params.maxQuantity !== undefined) qp.append('maxQuantity', String(params.maxQuantity));
      if (params.createdFrom) qp.append('createdFrom', params.createdFrom);
      if (params.createdTo) qp.append('createdTo', params.createdTo);
      if (params.hideZeroStock !== undefined) qp.append('hideZeroStock', String(params.hideZeroStock));
      if (params.hidePositiveStock !== undefined) qp.append('hidePositiveStock', String(params.hidePositiveStock));
      if (params.categoryIds) params.categoryIds.forEach(id => qp.append('categoryIds', id));
      if (params.brandIds) params.brandIds.forEach(id => qp.append('brandIds', id));
      if (params.onlyWithoutImage !== undefined) qp.append('onlyWithoutImage', String(params.onlyWithoutImage));
      const qs = qp.toString();
      if (qs) url += `?${qs}`;
    }
    return url;
  }, // Stok özet istatistikleri (filtre destekli)
  WAREHOUSE_SUMMARY: `${API_BASE_URL}/api/Inventory/warehouse-summary`, // Depo dashboard özeti (kritik stok, giriş/çıkış, hareketsiz)

  // Invoice Endpoints (Fatura)
  INVOICE_CREATE: `${API_BASE_URL}/api/accounting/invoice`, // ESKİ: Sadece fatura kaydet (stok/cari YOK)
  INVOICE_CREATE_COMPLETE: `${API_BASE_URL}/api/accounting/invoice/create-complete`, // YENİ ATOMİK: Fatura + Stok + Cari tek transaction'da
  INVOICE_BY_COMPANY: (params?: { page?: number; pageSize?: number; search?: string; invoiceType?: string; eInvoiceProfileType?: string; sortColumn?: string; sortDirection?: string; branchId?: string }) => {
    const base = `${API_BASE_URL}/api/accounting/invoice`;
    if (!params) return base;
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.set('page', params.page.toString());
    if (params.pageSize) searchParams.set('pageSize', params.pageSize.toString());
    if (params.search) searchParams.set('search', params.search);
    if (params.invoiceType && params.invoiceType !== 'all') searchParams.set('invoiceType', params.invoiceType.toUpperCase());
    if (params.eInvoiceProfileType && params.eInvoiceProfileType !== 'all') searchParams.set('eInvoiceProfileType', params.eInvoiceProfileType);
    if (params.sortColumn) searchParams.set('sortColumn', params.sortColumn);
    if (params.sortDirection) searchParams.set('sortDirection', params.sortDirection);
    if (params.branchId && params.branchId !== 'all') searchParams.set('branchId', params.branchId);
    const qs = searchParams.toString();
    return qs ? `${base}?${qs}` : base;
  }, // Server-side pagination + sorting + branch filter
  INVOICE_BY_ID: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}`,
  INVOICE_PREVIEW_NUMBER: `${API_BASE_URL}/api/accounting/invoice/preview-number`, // Sonraki fatura numarası önizleme
  INVOICE_RELATED_TRANSACTIONS: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}/related-transactions`, // Faturaya bağlı tüm hareketleri getir (silme öncesi kontrol)
  INVOICE_RETURN_SUMMARY: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}/return-summary`, // İade durumu özeti (kalem bazında kalan iade edilebilir miktar + durum)
  INVOICE_PROCESS_STOCK: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}/process-stock`, // Alış faturası stok girişi (POST)
  INVOICE_PROCESS_ACCOUNT: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}/process-account`, // Alış faturası cari işle (POST)
  INVOICE_PROCESS_SALES_STOCK: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}/process-sales-stock`, // Satış faturası stok çıkışı (POST)
  INVOICE_PROCESS_SALES_ACCOUNT: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}/process-sales-account`, // Satış faturası cari işle (POST)
  INVOICE_UPDATE: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}/update`, // Fatura güncelle (POST)
  INVOICE_UPDATE_EINVOICE_STATUS: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/update-einvoice-status/${invoiceId}`, // E-Fatura durumu güncelle (PUT)
  INVOICE_DELETE: (invoiceId: string) => `${API_BASE_URL}/api/accounting/invoice/${invoiceId}/delete`, // Fatura sil (POST - sunucu kısıtlaması)
  INVOICE_PARSE_PDF: `${API_BASE_URL}/api/accounting/invoice/parse-pdf`, // PDF'den fatura parse et (POST)
  INVOICE_PARSE_EINVOICE: `${API_BASE_URL}/api/accounting/invoice/parse-einvoice`, // E-faturadan ürün parse et (POST)
  INVOICE_REPORTS: `${API_BASE_URL}/api/accounting/invoice/reports`, // Fatura raporları (tarih filtreleme, silinmiş dahil)
  INVOICE_REPORTS_PAGED: (params: {
    startDate: string; endDate: string;
    page: number; pageSize: number;
    includeDeleted?: string; invoiceType?: string;
    searchTerm?: string; sortColumn?: string; sortDirection?: string;
  }) => {
    const p = new URLSearchParams();
    p.append('startDate', params.startDate);
    p.append('endDate', params.endDate);
    p.append('page', params.page.toString());
    p.append('pageSize', params.pageSize.toString());
    if (params.includeDeleted) p.append('includeDeleted', params.includeDeleted);
    if (params.invoiceType) p.append('invoiceType', params.invoiceType);
    if (params.searchTerm) p.append('searchTerm', params.searchTerm);
    if (params.sortColumn) p.append('sortColumn', params.sortColumn);
    if (params.sortDirection) p.append('sortDirection', params.sortDirection);
    return `${API_BASE_URL}/api/accounting/invoice/reports-paged?${p.toString()}`;
  },
  
  // ========== OFFER (TEKLİF) ENDPOINTS ==========
  OFFER_CREATE: `${API_BASE_URL}/api/accounting/Offer/create`, // Teklif oluştur
  OFFER_UPDATE: `${API_BASE_URL}/api/accounting/Offer/update`, // Teklif güncelle
  OFFER_DELETE: `${API_BASE_URL}/api/accounting/Offer/delete`, // Teklif sil (soft delete)
  OFFER_BY_COMPANY: `${API_BASE_URL}/api/accounting/Offer/by-company`, // Şirkete ait teklifler
  OFFER_BY_COMPANY_PAGED: (params: { page: number; pageSize: number; searchTerm?: string; sortColumn?: string; sortDirection?: string; offerType?: string; status?: string }) => {
    const p = new URLSearchParams();
    p.append('page', params.page.toString());
    p.append('pageSize', params.pageSize.toString());
    if (params.searchTerm) p.append('searchTerm', params.searchTerm);
    if (params.sortColumn) p.append('sortColumn', params.sortColumn);
    if (params.sortDirection) p.append('sortDirection', params.sortDirection);
    if (params.offerType) p.append('offerType', params.offerType);
    if (params.status) p.append('status', params.status);
    return `${API_BASE_URL}/api/accounting/Offer/by-company-paged?${p.toString()}`;
  },
  OFFER_BY_ID: (offerId: string) => `${API_BASE_URL}/api/accounting/Offer/${offerId}`, // Tek teklif getir
  OFFER_BY_TYPE: (offerType: string) => `${API_BASE_URL}/api/accounting/Offer/by-type/${offerType}`, // Teklif tipine göre
  OFFER_BY_STATUS: (status: string) => `${API_BASE_URL}/api/accounting/Offer/by-status/${status}`, // Duruma göre
  OFFER_ACTIVE: `${API_BASE_URL}/api/accounting/Offer/active`, // Aktif teklifler
  OFFER_EXPIRED: `${API_BASE_URL}/api/accounting/Offer/expired`, // Süresi geçmiş teklifler
  OFFER_CONVERT_TO_INVOICE: `${API_BASE_URL}/api/accounting/Offer/convert-to-invoice`, // Teklifi faturaya çevir

  // ========== OFFER TEMPLATE (TEKLİF ŞABLONU) ENDPOINTS ==========
  OFFER_TEMPLATE_LIST: `${API_BASE_URL}/api/accounting/OfferTemplate/by-company`,
  OFFER_TEMPLATE_BY_ID: (id: string) => `${API_BASE_URL}/api/accounting/OfferTemplate/${id}`,
  OFFER_TEMPLATE_DEFAULT: `${API_BASE_URL}/api/accounting/OfferTemplate/default`,
  OFFER_TEMPLATE_CREATE: `${API_BASE_URL}/api/accounting/OfferTemplate/create`,
  OFFER_TEMPLATE_UPDATE: `${API_BASE_URL}/api/accounting/OfferTemplate/update`,
  OFFER_TEMPLATE_SET_DEFAULT: (id: string) => `${API_BASE_URL}/api/accounting/OfferTemplate/set-default/${id}`,
  OFFER_TEMPLATE_DELETE: `${API_BASE_URL}/api/accounting/OfferTemplate/delete`,
  OFFER_TEMPLATE_IMAGE_PROXY: `${API_BASE_URL}/api/accounting/OfferTemplate/image-proxy`,

  // ========== WAYBILL (İRSALİYE) ENDPOINTS ==========
  WAYBILL_CREATE: `${API_BASE_URL}/api/accounting/Waybill/create`, // İrsaliye oluştur
  WAYBILL_UPDATE: `${API_BASE_URL}/api/accounting/Waybill/update`, // İrsaliye güncelle
  WAYBILL_DELETE: `${API_BASE_URL}/api/accounting/Waybill/delete`, // İrsaliye sil (soft delete)
  WAYBILL_BY_COMPANY: `${API_BASE_URL}/api/accounting/Waybill/by-company`, // Şirkete ait irsaliyeler
  WAYBILL_BY_COMPANY_PAGED: (params: { page: number; pageSize: number; searchTerm?: string; sortColumn?: string; sortDirection?: string }) => {
    const p = new URLSearchParams();
    p.append('page', params.page.toString());
    p.append('pageSize', params.pageSize.toString());
    if (params.searchTerm) p.append('searchTerm', params.searchTerm);
    if (params.sortColumn) p.append('sortColumn', params.sortColumn);
    if (params.sortDirection) p.append('sortDirection', params.sortDirection);
    return `${API_BASE_URL}/api/accounting/Waybill/by-company-paged?${p.toString()}`;
  },
  WAYBILL_BY_ID: (waybillId: string) => `${API_BASE_URL}/api/accounting/Waybill/${waybillId}`, // Tek irsaliye getir
  WAYBILL_BY_ACCOUNT: (accountId: string) => `${API_BASE_URL}/api/accounting/Waybill/by-account/${accountId}`, // Cariye ait irsaliyeler
  WAYBILL_BY_DATE_RANGE: (startDate: string, endDate: string) => `${API_BASE_URL}/api/accounting/Waybill/by-date-range?startDate=${startDate}&endDate=${endDate}`, // Tarih aralığı
  WAYBILL_SEARCH: (searchTerm: string) => `${API_BASE_URL}/api/accounting/Waybill/search?searchTerm=${searchTerm}`, // İrsaliye ara
  WAYBILL_PREVIEW_NUMBER: `${API_BASE_URL}/api/accounting/Waybill/preview-number`, // Sonraki irsaliye numarası önizleme
  WAYBILL_SUMMARY: `${API_BASE_URL}/api/accounting/Waybill/summary`, // İrsaliye dashboard özeti

  // ========== ORDER (SİPARİŞ) ENDPOINTS ==========
  ORDER_CREATE: `${API_BASE_URL}/api/accounting/Order/create`, // Sipariş oluştur
  ORDER_UPDATE: `${API_BASE_URL}/api/accounting/Order/update`, // Sipariş güncelle (POST)
  ORDER_DELETE: `${API_BASE_URL}/api/accounting/Order/delete`, // Sipariş sil (POST, soft delete)
  ORDER_BY_COMPANY: `${API_BASE_URL}/api/accounting/Order/by-company`, // Şirkete ait siparişler
  ORDER_BY_COMPANY_PAGED: (params: { page: number; pageSize: number; searchTerm?: string; sortColumn?: string; sortDirection?: string; orderType?: string; status?: string }) => {
    const p = new URLSearchParams();
    p.append('page', params.page.toString());
    p.append('pageSize', params.pageSize.toString());
    if (params.searchTerm) p.append('searchTerm', params.searchTerm);
    if (params.sortColumn) p.append('sortColumn', params.sortColumn);
    if (params.sortDirection) p.append('sortDirection', params.sortDirection);
    if (params.orderType) p.append('orderType', params.orderType);
    if (params.status) p.append('status', params.status);
    return `${API_BASE_URL}/api/accounting/Order/by-company-paged?${p.toString()}`;
  },
  ORDER_BY_ID: (orderId: string) => `${API_BASE_URL}/api/accounting/Order/${orderId}`, // Tek sipariş getir
  ORDER_BY_TYPE: (orderType: string) => `${API_BASE_URL}/api/accounting/Order/by-type/${orderType}`, // Tipe göre siparişler
  ORDER_BY_STATUS: (status: string) => `${API_BASE_URL}/api/accounting/Order/by-status/${status}`, // Duruma göre siparişler
  ORDER_SEARCH: (searchTerm: string) => `${API_BASE_URL}/api/accounting/Order/search?q=${searchTerm}`, // Sipariş ara
  ORDER_STATS: `${API_BASE_URL}/api/accounting/Order/stats`, // Sipariş istatistikleri
  ORDER_CONVERT_TO_INVOICE: `${API_BASE_URL}/api/accounting/Order/convert-to-invoice`, // Siparişi faturaya dönüştür

  // Currency (Döviz Kurları)
  CURRENCY_TCMB_RATES: `${API_BASE_URL}/api/Currency/tcmb-rates`,
  CURRENCY_SETTINGS: `${API_BASE_URL}/api/Currency/settings`,
  CURRENCY_LIST: `${API_BASE_URL}/api/Currency/list`,

  // ========== E-INVOICE INTEGRATION ENDPOINTS ==========
  EINVOICE_INTEGRATION_GET: `${API_BASE_URL}/api/accounting/EInvoiceIntegration`, // Aktif olanı getir
  EINVOICE_INTEGRATION_LIST: (includeDeleted: boolean = false) => `${API_BASE_URL}/api/accounting/EInvoiceIntegration/list?includeDeleted=${includeDeleted}`, // TÜM entegrasyonları getir
  EINVOICE_INTEGRATION_SAVE: `${API_BASE_URL}/api/accounting/EInvoiceIntegration/save`,
  EINVOICE_INTEGRATION_DELETE: `${API_BASE_URL}/api/accounting/EInvoiceIntegration/delete`,
  EINVOICE_INTEGRATION_TOGGLE_ACTIVE: `${API_BASE_URL}/api/accounting/EInvoiceIntegration/toggle-active`, // Aktif yapma (diğerleri pasif)
  EINVOICE_INTEGRATION_SYNC: `${API_BASE_URL}/api/accounting/EInvoiceIntegration/sync`,

  // ========== PAVOPAY INTEGRATION ENDPOINTS ==========
  PAVOPAY_INTEGRATION_LIST: `${API_BASE_URL}/api/accounting/PavoPayIntegration/list`,
  PAVOPAY_INTEGRATION_GET: (id: number) => `${API_BASE_URL}/api/accounting/PavoPayIntegration/${id}`,
  PAVOPAY_INTEGRATION_SAVE: `${API_BASE_URL}/api/accounting/PavoPayIntegration/save`,
  PAVOPAY_INTEGRATION_DELETE: `${API_BASE_URL}/api/accounting/PavoPayIntegration/delete`,
  PAVOPAY_INTEGRATION_TOGGLE_ACTIVE: `${API_BASE_URL}/api/accounting/PavoPayIntegration/toggle-active`,
  PAVOPAY_INTEGRATION_AUTH_TEST: `${API_BASE_URL}/api/accounting/PavoPayIntegration/auth-test`,
  PAVOPAY_INTEGRATION_LOGIN: `${API_BASE_URL}/api/accounting/PavoPayIntegration/login`,
  PAVOPAY_INTEGRATION_PROXY: `${API_BASE_URL}/api/accounting/PavoPayIntegration/proxy`,

  // Inventory Items
  INVENTORY_ITEMS: `${API_BASE_URL}/api/Inventory/items`,
  INVENTORY_ITEM_LIST: `${API_BASE_URL}/api/Inventory/items`, // Alias
  INVENTORY_ITEMS_PAGED: `${API_BASE_URL}/api/Inventory/items/paged`,
  INVENTORY_ITEM_BY_ID: (id: string) => `${API_BASE_URL}/api/Inventory/items/${id}`,
  INVENTORY_ITEM_BY_STOCK_CODE: (stockCode: string) => `${API_BASE_URL}/api/Inventory/items/stock-code/${stockCode}`,
  INVENTORY_ITEM_CREATE: `${API_BASE_URL}/api/Inventory/items`,
  INVENTORY_ITEM_UPDATE: (id: string) => `${API_BASE_URL}/api/Inventory/items/${id}/update`,
  INVENTORY_ITEM_DELETE: (id: string) => `${API_BASE_URL}/api/Inventory/items/${id}/delete`,
  INVENTORY_ITEM_UPDATE_QUANTITY: `${API_BASE_URL}/api/Inventory/items/quantity/update`,
  INVENTORY_ITEM_UPDATE_PRICE: `${API_BASE_URL}/api/Inventory/items/price/update`,
  INVENTORY_ITEM_BULK_UPDATE_STATUS: `${API_BASE_URL}/api/Inventory/items/bulk-update-status`,
  INVENTORY_ITEM_BULK_DELETE: `${API_BASE_URL}/api/Inventory/items/bulk-delete`,
  INVENTORY_ITEM_BULK_CREATE: `${API_BASE_URL}/api/Inventory/items/bulk-create`,
  INVENTORY_ITEM_BULK_UPDATE_PRICE: `${API_BASE_URL}/api/Inventory/items/bulk-update-price`,
  INVENTORY_ITEM_BULK_TOGGLE_ECOMMERCE: `${API_BASE_URL}/api/Inventory/items/bulk-toggle-ecommerce`,
  INVENTORY_ITEM_BULK_ASSIGN_WAREHOUSE: `${API_BASE_URL}/api/Inventory/items/bulk-assign-warehouse`,
  INVENTORY_ITEM_BULK_UPDATE_VAT_RATE: `${API_BASE_URL}/api/Inventory/items/bulk-update-vat-rate`,
  INVENTORY_ITEM_BULK_UPDATE_DEPARTMENT_NO: `${API_BASE_URL}/api/Inventory/items/bulk-update-department-no`,
  INVENTORY_ITEM_RESOLVE_BY_BARCODES: `${API_BASE_URL}/api/Inventory/items/resolve-by-barcodes`,
  INVENTORY_ITEM_BULK_APPEND_IMAGES: `${API_BASE_URL}/api/Inventory/items/bulk-append-images`,
  INVENTORY_ITEM_TOGGLE_ECOMMERCE: (productId: string, enable: boolean) => 
    `${API_BASE_URL}/api/Inventory/items/${productId}/ecommerce?enable=${enable}`,
  INVENTORY_ITEMS_ECOMMERCE: `${API_BASE_URL}/api/Inventory/items/ecommerce`,
  INVENTORY_ITEM_FEATURE_VALUES: (itemId: string) => `${API_BASE_URL}/api/Inventory/items/${itemId}/feature-values`,
  
  // ========== IMAGE LIBRARY ENDPOINTS ==========
  
  // Image Library Folders
  IMAGE_LIBRARY_FOLDERS: `${API_BASE_URL}/api/ImageLibrary/folders`,
  IMAGE_LIBRARY_FOLDER_CREATE: `${API_BASE_URL}/api/ImageLibrary/folders`,
  IMAGE_LIBRARY_FOLDER_UPDATE: (id: string) => `${API_BASE_URL}/api/ImageLibrary/folders/${id}/update`,
  IMAGE_LIBRARY_FOLDER_DELETE: (id: string) => `${API_BASE_URL}/api/ImageLibrary/folders/${id}/delete`,
  
  // Image Library Images
  IMAGE_LIBRARY_IMAGES: `${API_BASE_URL}/api/ImageLibrary/images`,
  IMAGE_LIBRARY_IMAGES_BY_FOLDER: (folderId?: string) => {
    const params = folderId ? `?folderId=${folderId}` : '';
    return `${API_BASE_URL}/api/ImageLibrary/images/folder${params}`;
  },
  IMAGE_LIBRARY_IMAGE_CREATE: `${API_BASE_URL}/api/ImageLibrary/images`,
  IMAGE_LIBRARY_IMAGE_UPDATE: (id: string) => `${API_BASE_URL}/api/ImageLibrary/images/${id}/update`,
  IMAGE_LIBRARY_IMAGE_DELETE: (id: string) => `${API_BASE_URL}/api/ImageLibrary/images/${id}/delete`,

  // ========== SMART WAREHOUSE (WMS) ENDPOINTS ==========
  SMART_WAREHOUSES: `${WMS_BASE_URL}/api/SmartWarehouse`,
  SMART_WAREHOUSE_BY_ID: (id: string) => `${WMS_BASE_URL}/api/SmartWarehouse/${id}`,
  SMART_WAREHOUSE_CREATE: `${WMS_BASE_URL}/api/SmartWarehouse/create`,
  SMART_WAREHOUSE_UPDATE: `${WMS_BASE_URL}/api/SmartWarehouse/update`,
  SMART_WAREHOUSE_DELETE: `${WMS_BASE_URL}/api/SmartWarehouse/delete`,
  SMART_WAREHOUSE_SUMMARY: (id: string) => `${WMS_BASE_URL}/api/SmartWarehouse/${id}/summary`,

  // ========== SMART WAREHOUSE ENTRY/EXIT ENDPOINTS ==========
  SW_ENTRY_EXIT: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouse/${warehouseId}/entry-exit`,
  SW_ENTRY_EXIT_CREATE: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouse/${warehouseId}/entry-exit/create`,
  SW_ENTRY_EXIT_UPDATE: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouse/${warehouseId}/entry-exit/update`,
  SW_ENTRY_EXIT_DELETE: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouse/${warehouseId}/entry-exit/delete`,

  // ========== SMART WAREHOUSE LOCATION ENDPOINTS ==========
  SWL_BY_WAREHOUSE: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouseLocation/by-warehouse/${warehouseId}`,
  SWL_TREE: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouseLocation/tree/${warehouseId}`,
  SWL_BY_ID: (id: string) => `${WMS_BASE_URL}/api/SmartWarehouseLocation/${id}`,
  SWL_CREATE: `${WMS_BASE_URL}/api/SmartWarehouseLocation/create`,
  SWL_BULK_CREATE: `${WMS_BASE_URL}/api/SmartWarehouseLocation/bulk-create`,
  SWL_UPDATE: `${WMS_BASE_URL}/api/SmartWarehouseLocation/update`,
  SWL_DELETE: `${WMS_BASE_URL}/api/SmartWarehouseLocation/delete`,
  SWL_UPDATE_GRID: `${WMS_BASE_URL}/api/SmartWarehouseLocation/update-grid`,
  SWL_BULK_UPDATE_GRID: `${WMS_BASE_URL}/api/SmartWarehouseLocation/bulk-update-grid`,
  SWL_BATCH_SAVE: `${WMS_BASE_URL}/api/SmartWarehouseLocation/batch-save`,
  SWL_CALC_SORT_ORDER: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouseLocation/calculate-sort-order/${warehouseId}`,
  SWL_SORT_ORDER_PREVIEW: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouseLocation/sort-order-preview/${warehouseId}`,
  SWL_GENERATE_BARCODE: (id: string) => `${WMS_BASE_URL}/api/SmartWarehouseLocation/generate-barcode/${id}`,
  SWL_OBSTACLES: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouseLocation/obstacles/${warehouseId}`,

  // ========== WMS EQUIPMENT ENDPOINTS ==========
  WMS_CARTS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsEquipment/carts/${warehouseId}`,
  WMS_CART_DETAIL: (id: string) => `${WMS_BASE_URL}/api/WmsEquipment/carts/detail/${id}`,
  WMS_CART_CREATE: `${WMS_BASE_URL}/api/WmsEquipment/carts/create`,
  WMS_CART_UPDATE: `${WMS_BASE_URL}/api/WmsEquipment/carts/update`,
  WMS_CART_DELETE: `${WMS_BASE_URL}/api/WmsEquipment/carts/delete`,
  WMS_CART_BARCODE: (id: string) => `${WMS_BASE_URL}/api/WmsEquipment/carts/${id}/generate-barcode`,
  WMS_SHELVES: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsEquipment/shelves/${warehouseId}`,
  WMS_SHELF_DETAIL: (id: string) => `${WMS_BASE_URL}/api/WmsEquipment/shelves/detail/${id}`,
  WMS_SHELF_CREATE: `${WMS_BASE_URL}/api/WmsEquipment/shelves/create`,
  WMS_SHELF_UPDATE: `${WMS_BASE_URL}/api/WmsEquipment/shelves/update`,
  WMS_SHELF_DELETE: `${WMS_BASE_URL}/api/WmsEquipment/shelves/delete`,
  WMS_SLOT_UPDATE: `${WMS_BASE_URL}/api/WmsEquipment/slots/update`,
  WMS_SLOT_CLEAR: (id: string) => `${WMS_BASE_URL}/api/WmsEquipment/slots/${id}/clear`,
  WMS_SLOT_BARCODE: (id: string) => `${WMS_BASE_URL}/api/WmsEquipment/slots/${id}/generate-barcode`,

  // ========== WMS ORDER ENDPOINTS ==========
  WMS_ORDERS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsOrder/by-warehouse/${warehouseId}`,
  WMS_ORDER_DETAIL: (id: string) => `${WMS_BASE_URL}/api/WmsOrder/${id}`,
  WMS_ORDER_CREATE: `${WMS_BASE_URL}/api/WmsOrder/create`,
  WMS_ORDER_UPDATE: `${WMS_BASE_URL}/api/WmsOrder/update`,
  WMS_ORDER_DELETE: `${WMS_BASE_URL}/api/WmsOrder/delete`,
  WMS_ORDER_CANCEL: (id: string) => `${WMS_BASE_URL}/api/WmsOrder/cancel/${id}`,
  WMS_ORDER_RESOLVE_CANCEL: `${WMS_BASE_URL}/api/WmsOrder/resolve-cancel`,
  WMS_ORDER_CLASSIFY: (id: string) => `${WMS_BASE_URL}/api/WmsOrder/classify/${id}`,
  WMS_ORDER_STOCK_CHECK: (warehouseId: string, orderId: string) => `${WMS_BASE_URL}/api/WmsOrder/stock-check/${warehouseId}/${orderId}`,
  WMS_ORDER_STOCK_CHECK_BATCH: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsOrder/stock-check-batch/${warehouseId}`,
  WMS_ORDER_SUMMARY: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsOrder/summary/${warehouseId}`,
  WMS_ORDER_CHANNEL_SUMMARY: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsOrder/channel-summary/${warehouseId}`,
  WMS_ORDER_WAVE_CANDIDATES: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsOrder/wave-candidates/${warehouseId}`,
  WMS_ORDER_ASSIGN_PERSONNEL: `${WMS_BASE_URL}/api/WmsOrderAssignment/assign-personnel`,
  WMS_ORDER_UNASSIGN_PERSONNEL: `${WMS_BASE_URL}/api/WmsOrderAssignment/unassign`,
  WMS_ORDER_BY_PERSONNEL: `${WMS_BASE_URL}/api/WmsOrderAssignment/by-personnel`,

  // WMS Wave / Is Emri
  WMS_WAVES: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsWave/by-warehouse/${warehouseId}`,
  WMS_WAVE_DETAIL: (id: string) => `${WMS_BASE_URL}/api/WmsWave/${id}`,
  WMS_WAVE_CREATE: `${WMS_BASE_URL}/api/WmsWave/create`,
  WMS_WAVE_START_NEXT: `${WMS_BASE_URL}/api/WmsWave/start-next`,
  WMS_WAVE_SUGGEST_SMART_GROUPING: `${WMS_BASE_URL}/api/WmsWave/suggest-smart-grouping`,
  WMS_WAVE_CANCEL: (id: string) => `${WMS_BASE_URL}/api/WmsWave/cancel/${id}`,
  WMS_WAVE_RELEASE: (id: string) => `${WMS_BASE_URL}/api/WmsWave/release/${id}`,
  WMS_WAVE_DELETE: (id: string) => `${WMS_BASE_URL}/api/WmsWave/delete/${id}`,
  WMS_WAVE_ASSIGN_PICKER: `${WMS_BASE_URL}/api/WmsWave/assign-picker`,
  WMS_WAVE_ASSIGN_PERSONNEL: `${WMS_BASE_URL}/api/WmsWave/assign-personnel-to-wave`,
  WMS_WAVE_ASSIGN_CART: `${WMS_BASE_URL}/api/WmsWave/assign-cart`,
  WMS_WAVE_UNASSIGN_PICKER: (id: string) => `${WMS_BASE_URL}/api/WmsWave/unassign-picker/${id}`,
  WMS_WAVE_UNASSIGN_PERSONNEL: (id: string) => `${WMS_BASE_URL}/api/WmsWave/unassign-personnel/${id}`,
  WMS_WAVE_UNASSIGN_CART: (id: string) => `${WMS_BASE_URL}/api/WmsWave/unassign-cart/${id}`,
  WMS_WAVE_START: (id: string) => `${WMS_BASE_URL}/api/WmsWave/start/${id}`,
  WMS_WAVE_COMPLETE: (id: string) => `${WMS_BASE_URL}/api/WmsWave/complete/${id}`,
  WMS_WAVE_PICK_LIST: (id: string) => `${WMS_BASE_URL}/api/WmsWave/${id}/pick-list`,
  WMS_WAVE_PICK_LIST_OPTIMIZED: (id: string) => `${WMS_BASE_URL}/api/WmsWave/${id}/pick-list-optimized`,
  WMS_WAVE_PICK_LIST_CONSOLIDATED: (id: string) => `${WMS_BASE_URL}/api/WmsWave/${id}/pick-list-consolidated`,
  WMS_WAREHOUSE_REBUILD_GRAPH: (warehouseId: string) => `${WMS_BASE_URL}/api/SmartWarehouse/${warehouseId}/rebuild-graph`,
  WMS_WAVE_SUMMARY: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsWave/summary/${warehouseId}`,
  WMS_WAVE_ACTIVE: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsWave/active/${warehouseId}`,
  WMS_WAVE_BY_PERSONNEL: `${WMS_BASE_URL}/api/WmsWave/by-personnel`,
  WMS_WAVE_PICK_ITEM: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/pick-item`,
  WMS_WAVE_PICK_CONSOLIDATED: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/pick-consolidated`,
  WMS_WAVE_ADJUST_STOCK: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/adjust-stock`,
  WMS_WAVE_LOCATION_SUGGESTION: (waveId: string, productId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/location-suggestion/${productId}`,
  WMS_WAVE_ASSIGN_LOCATION: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/assign-location`,
  WMS_WAVE_SHORT_PICK: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/short-pick-item`,
  WMS_WAVE_COMPLETE_PICKING: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/complete-picking`,
  WMS_WAVE_PICKING_PROGRESS: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/picking-progress`,
  WMS_WAVE_SORT_ITEM: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/sort-item`,
  WMS_WAVE_COMPLETE_SORTING: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/complete-sorting`,
  WMS_WAVE_SORTING_STATUS: (waveId: string) => `${WMS_BASE_URL}/api/WmsWave/${waveId}/sorting-status`,

  // WMS Screens
  WMS_SCREENS: (type: string, warehouseId: string) => `${WMS_BASE_URL}/api/WmsScreen/${type}/by-warehouse/${warehouseId}`,
  WMS_SCREEN_DETAIL: (type: string, id: string) => `${WMS_BASE_URL}/api/WmsScreen/${type}/${id}`,
  WMS_SCREEN_CREATE: (type: string) => `${WMS_BASE_URL}/api/WmsScreen/${type}/create`,
  WMS_SCREEN_UPDATE: (type: string) => `${WMS_BASE_URL}/api/WmsScreen/${type}/update`,
  WMS_SCREEN_DELETE: (type: string) => `${WMS_BASE_URL}/api/WmsScreen/${type}/delete`,
  WMS_SCREEN_CASHIERS: (type: string, screenId: string) => `${WMS_BASE_URL}/api/WmsScreen/${type}/${screenId}/cashiers`,
  WMS_SCREEN_ADD_CASHIER: (type: string, screenId: string) => `${WMS_BASE_URL}/api/WmsScreen/${type}/${screenId}/cashiers/add`,
  WMS_SCREEN_REMOVE_CASHIER: (type: string, screenId: string) => `${WMS_BASE_URL}/api/WmsScreen/${type}/${screenId}/cashiers/remove`,

  // WMS Packing
  WMS_PACKING_PENDING: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsPacking/pending/${warehouseId}`,
  WMS_PACKING_FIND_BARCODE: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsPacking/find-by-barcode/${warehouseId}`,
  WMS_PACKING_FIND_CART: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsPacking/find-by-cart/${warehouseId}`,
  WMS_PACKING_ORDER: (orderId: string) => `${WMS_BASE_URL}/api/WmsPacking/order/${orderId}`,
  WMS_PACKING_START: `${WMS_BASE_URL}/api/WmsPacking/start-packing`,
  WMS_PACKING_PACK_ITEM: `${WMS_BASE_URL}/api/WmsPacking/pack-item`,
  WMS_PACKING_COMPLETE: `${WMS_BASE_URL}/api/WmsPacking/complete-packing`,
  WMS_PACKING_SHORT: `${WMS_BASE_URL}/api/WmsPacking/short-pack`,
  WMS_PACKING_LABEL: (orderId: string) => `${WMS_BASE_URL}/api/WmsPacking/label/${orderId}`,
  WMS_PACKING_STATS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsPacking/stats/${warehouseId}`,
  WMS_PACKING_COMPLETED: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsPacking/completed/${warehouseId}`,

  // WMS Receiving
  WMS_RECEIVING_SESSIONS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsReceiving/sessions/${warehouseId}`,
  WMS_RECEIVING_SESSION_DETAIL: (warehouseId: string, sessionId: string) => `${WMS_BASE_URL}/api/WmsReceiving/sessions/${warehouseId}/${sessionId}`,
  WMS_RECEIVING_SESSION_CREATE: `${WMS_BASE_URL}/api/WmsReceiving/sessions/create`,
  WMS_RECEIVING_SESSION_COMPLETE: (sessionId: string) => `${WMS_BASE_URL}/api/WmsReceiving/sessions/${sessionId}/complete`,
  WMS_RECEIVING_SESSION_CANCEL: (sessionId: string) => `${WMS_BASE_URL}/api/WmsReceiving/sessions/${sessionId}/cancel`,
  WMS_RECEIVING_SESSION_ASSIGN_PERSONNEL: (sessionId: string) => `${WMS_BASE_URL}/api/WmsReceiving/sessions/${sessionId}/assign-personnel`,
  WMS_RECEIVING_RECEIVE_ITEM: `${WMS_BASE_URL}/api/WmsReceiving/receive-item`,
  WMS_RECEIVING_UPDATE_QTY: `${WMS_BASE_URL}/api/WmsReceiving/receive-item/update-qty`,
  WMS_RECEIVING_REMOVE_ITEM: `${WMS_BASE_URL}/api/WmsReceiving/receive-item/remove`,
  WMS_RECEIVING_PUTAWAY_SUGGESTION: (warehouseId: string, productId: string) => `${WMS_BASE_URL}/api/WmsReceiving/putaway-suggestion/${warehouseId}/${productId}`,
  WMS_RECEIVING_PUTAWAY: `${WMS_BASE_URL}/api/WmsReceiving/putaway`,
  WMS_RECEIVING_PUTAWAY_BULK: `${WMS_BASE_URL}/api/WmsReceiving/putaway-bulk`,
  WMS_RECEIVING_STATS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsReceiving/stats/${warehouseId}`,

  // WMS Cycle Count
  WMS_CC_TASKS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/tasks/${warehouseId}`,
  WMS_CC_TASK_DETAIL: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/tasks/detail/${taskId}`,
  WMS_CC_TASK_CREATE: `${WMS_BASE_URL}/api/WmsCycleCount/tasks/create`,
  WMS_CC_CRITERIA_PREVIEW: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/criteria-preview/${warehouseId}`,
  WMS_CC_PRODUCT_SEARCH: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/product-search/${warehouseId}`,
  WMS_CC_TASK_ASSIGN: `${WMS_BASE_URL}/api/WmsCycleCount/tasks/assign`,
  WMS_CC_TASK_CANCEL: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/tasks/cancel/${taskId}`,
  WMS_CC_TASK_REQUEST_CANCEL: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/tasks/request-cancel/${taskId}`,
  WMS_CC_MY_TASKS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/my-tasks/${warehouseId}`,
  WMS_CC_MY_TASKS_BY_PERSONNEL: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/my-tasks-by-personnel/${warehouseId}`,
  WMS_CC_TASK_ASSIGN_PERSONNEL: `${WMS_BASE_URL}/api/WmsCycleCount/tasks/assign-personnel`,
  WMS_CC_START: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/start/${taskId}`,
  WMS_CC_TASK_LOCATIONS: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/task-locations/${taskId}`,
  WMS_CC_LOCATION_PRODUCTS: (taskId: string, locationId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/location-products/${taskId}/${locationId}`,
  WMS_CC_COUNT_LOCATION: `${WMS_BASE_URL}/api/WmsCycleCount/count-location`,
  WMS_CC_COMPLETE: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/complete/${taskId}`,
  WMS_CC_DISCREPANCY: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/discrepancy-report/${taskId}`,
  WMS_CC_APPROVE: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/approve-adjustments/${taskId}`,
  WMS_CC_REJECT: (taskId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/reject-adjustments/${taskId}`,
  WMS_CC_STATS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/stats/${warehouseId}`,
  WMS_CC_TODAY_PRODUCTS: (warehouseId: string) => `${WMS_BASE_URL}/api/WmsCycleCount/today-products/${warehouseId}`,

  // WMS Dashboard & Reports
  WMS_DASHBOARD_SUMMARY: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/summary/${wId}`,
  WMS_DASHBOARD_HOURLY: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/hourly/${wId}`,
  WMS_DASHBOARD_THROUGHPUT: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/throughput/${wId}`,
  WMS_DASHBOARD_ACTIVE_WAVES: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/active-waves/${wId}`,
  WMS_DASHBOARD_FEED: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/activity-feed/${wId}`,
  WMS_REPORT_OVERVIEW: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/report/overview/${wId}`,
  WMS_REPORT_PICKING: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/report/picking/${wId}`,
  WMS_REPORT_PACKING: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/report/packing/${wId}`,
  WMS_REPORT_RECEIVING: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/report/receiving/${wId}`,
  WMS_REPORT_COUNTING: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/report/counting/${wId}`,
  WMS_REPORT_SHORT_PICKS: (wId: string) => `${WMS_BASE_URL}/api/WmsDashboard/report/short-picks/${wId}`,

  // WMS Order Transfer
  WMS_TRANSFER: `${WMS_BASE_URL}/api/WmsOrderTransfer/transfer`,
  WMS_TRANSFER_BULK: `${WMS_BASE_URL}/api/WmsOrderTransfer/transfer-bulk`,
  WMS_TRANSFER_STATUS: (ecomOrderId: string) => `${WMS_BASE_URL}/api/WmsOrderTransfer/transfer-status/${ecomOrderId}`,
  WMS_TRANSFER_STATUS_BULK: `${WMS_BASE_URL}/api/WmsOrderTransfer/transfer-status-bulk`,
  WMS_TRANSFER_PREVIEW: `${WMS_BASE_URL}/api/WmsOrderTransfer/preview`,
  WMS_AUTO_TRANSFER_SETTINGS: (wId: string) => `${WMS_BASE_URL}/api/WmsOrderTransfer/auto-transfer-settings/${wId}`,
  WMS_AUTO_TRANSFER_UPDATE: `${WMS_BASE_URL}/api/WmsOrderTransfer/auto-transfer-settings/update`,
  ECOMMERCE_ORDERS_BULK_RETRY_WMS: `${ECOMMERCE_API_URL}/api/ecommerce/orders/bulk-retry-wms-transfer`,

  // WMS Cargo
  WMS_CARGO_SETTINGS: (wId: string) => `${WMS_BASE_URL}/api/WmsCargo/settings/${wId}`,
  WMS_CARGO_SETTINGS_CREATE: `${WMS_BASE_URL}/api/WmsCargo/settings/create`,
  WMS_CARGO_SETTINGS_UPDATE: `${WMS_BASE_URL}/api/WmsCargo/settings/update`,
  WMS_CARGO_SETTINGS_DELETE: `${WMS_BASE_URL}/api/WmsCargo/settings/delete`,
  WMS_CARGO_TEST: `${WMS_BASE_URL}/api/WmsCargo/settings/test-connection`,
  WMS_CARGO_PROVIDERS: `${WMS_BASE_URL}/api/WmsCargo/providers`,
  WMS_CARGO_CREATE_SHIPMENT: `${WMS_BASE_URL}/api/WmsCargo/create-shipment`,
  WMS_CARGO_CANCEL_SHIPMENT: `${WMS_BASE_URL}/api/WmsCargo/cancel-shipment`,
  WMS_CARGO_LABEL: (orderId: string) => `${WMS_BASE_URL}/api/WmsCargo/label/${orderId}`,
  WMS_CARGO_TRACKING: (orderId: string) => `${WMS_BASE_URL}/api/WmsCargo/tracking/${orderId}`,
  WMS_CARGO_TRACKING_BULK: (wId: string) => `${WMS_BASE_URL}/api/WmsCargo/tracking-bulk/${wId}`,
};

// ========== CARD MANAGEMENT API ENDPOINTS ==========
export const CARD_MANAGEMENT_API = {
  CARD_TYPES: `${API_BASE_URL}/api/CardManagement/card-types`,
  CARD_TYPE_CREATE: `${API_BASE_URL}/api/CardManagement/card-type/create`,
  CARD_TYPE_UPDATE: `${API_BASE_URL}/api/CardManagement/card-type/update`,
  CARD_TYPE_DELETE: `${API_BASE_URL}/api/CardManagement/card-type/delete`,

  WALLETS: `${API_BASE_URL}/api/CardManagement/wallets`,
  WALLET_CREATE: `${API_BASE_URL}/api/CardManagement/wallet/create`,
  WALLET_UPDATE: `${API_BASE_URL}/api/CardManagement/wallet/update`,
  WALLET_DELETE: `${API_BASE_URL}/api/CardManagement/wallet/delete`,

  CARDS: (params?: { page?: number; pageSize?: number; search?: string; cardTypeId?: number; walletId?: number; accountId?: string; sessionStatus?: string }) => {
    let url = `${API_BASE_URL}/api/CardManagement/cards`;
    if (params) {
      const qp = new URLSearchParams();
      if (params.page) qp.append('page', params.page.toString());
      if (params.pageSize) qp.append('pageSize', params.pageSize.toString());
      if (params.search) qp.append('search', params.search);
      if (params.cardTypeId) qp.append('cardTypeId', params.cardTypeId.toString());
      if (params.walletId) qp.append('walletId', params.walletId.toString());
      if (params.accountId) qp.append('accountId', params.accountId);
      if (params.sessionStatus) qp.append('sessionStatus', params.sessionStatus);
      const qs = qp.toString();
      if (qs) url += `?${qs}`;
    }
    return url;
  },
  CARD_BY_ID: (id: number) => `${API_BASE_URL}/api/CardManagement/card/${id}`,
  CARD_BY_UID: (cardUID: string) => `${API_BASE_URL}/api/CardManagement/card/by-uid/${cardUID}`,
  CARD_TRANSACTIONS: (id: number, params?: { page?: number; pageSize?: number; walletId?: number }) => {
    let url = `${API_BASE_URL}/api/CardManagement/card/${id}/transactions`;
    const qp = new URLSearchParams();
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    if (params?.walletId) qp.append('walletId', params.walletId.toString());
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  MASTER_CARDS: `${API_BASE_URL}/api/CardManagement/master-cards`,
  CARD_CREATE: `${API_BASE_URL}/api/CardManagement/card/create`,
  CARD_UPDATE: `${API_BASE_URL}/api/CardManagement/card/update`,
  CARD_PAIR_TURNSTILE_UID: `${API_BASE_URL}/api/CardManagement/card/pair-turnstile-uid`, // Turnike UID eşleştirme (Kart Eşleştirme modalı)
  CARD_DELETE: `${API_BASE_URL}/api/CardManagement/card/delete`,
  CARD_RESTORE: `${API_BASE_URL}/api/CardManagement/card/restore`,
  CARD_HARD_DELETE: `${API_BASE_URL}/api/CardManagement/card/hard-delete`,
  CARD_CHECK_EXISTS: (params?: { cardNumber?: string; cardUID?: string }) => {
    let url = `${API_BASE_URL}/api/CardManagement/card/check-exists`;
    const qp = new URLSearchParams();
    if (params?.cardNumber) qp.append('cardNumber', params.cardNumber);
    if (params?.cardUID) qp.append('cardUID', params.cardUID);
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  CARDS_DELETED: (params?: { page?: number; pageSize?: number; search?: string }) => {
    let url = `${API_BASE_URL}/api/CardManagement/cards/deleted`;
    const qp = new URLSearchParams();
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    if (params?.search) qp.append('search', params.search);
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },

  SESSION_OPEN: `${API_BASE_URL}/api/CardManagement/session/open`,
  SESSION_CLOSE: `${API_BASE_URL}/api/CardManagement/session/close`,
  SESSION_ACTIVE: (cardId: number) => `${API_BASE_URL}/api/CardManagement/session/active/${cardId}`,
  SESSION_HISTORY: (cardId: number, page?: number, pageSize?: number) => {
    let url = `${API_BASE_URL}/api/CardManagement/session/history/${cardId}`;
    const qp = new URLSearchParams();
    if (page) qp.append('page', page.toString());
    if (pageSize) qp.append('pageSize', pageSize.toString());
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  SESSION_TRANSACTIONS: (sessionId: number, page?: number, pageSize?: number) => {
    let url = `${API_BASE_URL}/api/CardManagement/session/${sessionId}/transactions`;
    const qp = new URLSearchParams();
    if (page) qp.append('page', page.toString());
    if (pageSize) qp.append('pageSize', pageSize.toString());
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },
  SESSIONS_ALL: (params?: { page?: number; pageSize?: number; cardId?: number; status?: string; search?: string }) => {
    let url = `${API_BASE_URL}/api/CardManagement/sessions`;
    const qp = new URLSearchParams();
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    if (params?.cardId) qp.append('cardId', params.cardId.toString());
    if (params?.status) qp.append('status', params.status);
    if (params?.search) qp.append('search', params.search);
    const qs = qp.toString();
    if (qs) url += `?${qs}`;
    return url;
  },

  LOAD_BALANCE: `${API_BASE_URL}/api/CardManagement/card/load-balance`,
  WITHDRAW_BALANCE: `${API_BASE_URL}/api/CardManagement/card/withdraw-balance`,
  CARD_PURCHASE: `${API_BASE_URL}/api/CardManagement/card/purchase`,
  REFUND_PURCHASE_ITEM: `${API_BASE_URL}/api/CardManagement/card/refund-purchase-item`,

  SESSION_PURCHASE_ITEMS: (sessionId: number, onlyUnreceipted?: boolean) =>
    `${API_BASE_URL}/api/CardManagement/session/${sessionId}/purchase-items${onlyUnreceipted ? '?onlyUnreceipted=true' : ''}`,

  MARK_SESSION_RECEIPTED: (sessionId: number) =>
    `${API_BASE_URL}/api/CardManagement/session/${sessionId}/mark-receipted`,

  STOCK_MOVEMENTS_BY_REFERENCE: (referenceId: string) =>
    `${API_BASE_URL}/api/StockMovement/by-reference/${encodeURIComponent(referenceId)}`,

  SUMMARY: `${API_BASE_URL}/api/CardManagement/summary`,
};

// ========== SALES API ENDPOINTS ==========
export const SALES_API = {
  // Quick Sale - Atomik İşlemler (Fatura + Stok + Cari)
  QUICK_SALE_CASH_WITH_INVOICE: `${SALESAPI_URL}/api/QuickSaleWithInvoice/process-cash-with-invoice`, // Nakit + Fatura (atomik)
  QUICK_SALE_POS_WITH_INVOICE: `${SALESAPI_URL}/api/QuickSaleWithInvoice/process-pos-with-invoice`, // POS + Fatura (atomik)
  QUICK_SALE_PARTIAL_WITH_INVOICE: `${SALESAPI_URL}/api/QuickSaleWithInvoice/process-partial-with-invoice`, // Karma + Fatura (atomik)
  
  // Eski endpoint'ler (fatura olmadan) - geriye uyumluluk için
  QUICK_SALE_CASH_PAYMENT: `${SALESAPI_URL}/api/QuickSaleCashPayment/process`, // Nakit (fatura yok)
  QUICK_SALE_POS_PAYMENT: `${SALESAPI_URL}/api/QuickSalePosPayment/process`, // POS (fatura yok)
  QUICK_SALE_POS_PAYMENT_SKIP_STOCK: `${SALESAPI_URL}/api/QuickSalePosPayment/process?skipStockMovement=true`, // POS (stok hareket yok)
  
  // Paket Sipariş Yönetimi
  PACKAGE_ORDER_CREATE: `${SALESAPI_URL}/api/PackageOrder/create`, // Yeni sipariş oluştur
  PACKAGE_ORDER_TODAY: (branchId?: string) => {
    const params = new URLSearchParams();
    if (branchId) params.append('branchId', branchId);
    const queryStr = params.toString();
    return `${SALESAPI_URL}/api/PackageOrder/today${queryStr ? '?' + queryStr : ''}`;
  },
  PACKAGE_ORDER_ACTIVE: (branchId?: string) => {
    const params = new URLSearchParams();
    if (branchId) params.append('branchId', branchId);
    const queryStr = params.toString();
    return `${SALESAPI_URL}/api/PackageOrder/active${queryStr ? '?' + queryStr : ''}`;
  },
  PACKAGE_ORDER_BY_DATE_RANGE: (startDate: string, endDate: string, branchId?: string) => {
    const params = new URLSearchParams({ startDate, endDate });
    if (branchId) params.append('branchId', branchId);
    return `${SALESAPI_URL}/api/PackageOrder/by-date-range?${params.toString()}`;
  },
  PACKAGE_ORDER_BY_ID: (id: number) => 
    `${SALESAPI_URL}/api/PackageOrder/${id}`,
  PACKAGE_ORDER_UPDATE_STATUS: `${SALESAPI_URL}/api/PackageOrder/update-status`, // Durum güncelle
  PACKAGE_ORDER_CANCEL: `${SALESAPI_URL}/api/PackageOrder/cancel`, // Sipariş iptal
  PACKAGE_ORDER_ASSIGN_COURIER: `${SALESAPI_URL}/api/PackageOrder/assign-courier`, // Kurye ata

  // Kulüp Girişi (Club Entry)
  CLUB_ENTRY_SETTINGS: (screenId: number) => `${SALESAPI_URL}/api/ClubEntry/settings/${screenId}`,
  CLUB_ENTRY_ASSIGN_CARDS: `${SALESAPI_URL}/api/ClubEntry/assign-cards`,
  CLUB_ENTRY_ASSIGN_CARDS_FROM_RESERVATION: `${SALESAPI_URL}/api/ClubEntry/assign-cards-from-reservation`,
  CLUB_ENTRY_CARDS_BY_SALE: (saleReceiptId: number) => `${SALESAPI_URL}/api/ClubEntry/cards-by-sale/${saleReceiptId}`,
  CLUB_ENTRY_CARD_LOOKUP: (cardUID: string) => `${SALESAPI_URL}/api/ClubEntry/card/${encodeURIComponent(cardUID)}`,
  CLUB_ENTRY_ACTIVE_CARDS: (params?: { screenId?: number; page?: number; pageSize?: number; search?: string }) => {
    const qp = new URLSearchParams();
    if (params?.screenId) qp.append('screenId', params.screenId.toString());
    if (params?.page) qp.append('page', params.page.toString());
    if (params?.pageSize) qp.append('pageSize', params.pageSize.toString());
    if (params?.search) qp.append('search', params.search);
    const qs = qp.toString();
    return `${SALESAPI_URL}/api/ClubEntry/active-cards${qs ? '?' + qs : ''}`;
  },
  CLUB_ENTRY_ACTIVE_CARDS_SUMMARY: (screenId?: number) => {
    const params = screenId ? `?screenId=${screenId}` : '';
    return `${SALESAPI_URL}/api/ClubEntry/active-cards-summary${params}`;
  },
  CLUB_ENTRY_DEPOSITS_SUMMARY: (params: { startDate: string; endDate: string; branchId?: string; screenId?: number }) => {
    const qp = new URLSearchParams();
    qp.append('startDate', params.startDate);
    qp.append('endDate', params.endDate);
    if (params.branchId) qp.append('branchId', params.branchId);
    if (params.screenId) qp.append('screenId', params.screenId.toString());
    return `${SALESAPI_URL}/api/ClubEntry/deposits-summary?${qp.toString()}`;
  },
  CLUB_ENTRY_GRANT_ENTRY_RIGHTS: `${SALESAPI_URL}/api/ClubEntry/grant-entry-rights`,
  CLUB_ENTRY_RIGHTS_BY_UIDS: `${SALESAPI_URL}/api/ClubEntry/entry-rights-by-uids`,
  CLUB_ENTRY_CONSUME_ENTRY_RIGHTS: `${SALESAPI_URL}/api/ClubEntry/consume-entry-rights`,
  CLUB_ENTRY_CHECK_AND_CONSUME: `${SALESAPI_URL}/api/ClubEntry/check-and-consume`,
  CLUB_ENTRY_RETURN_CARD: `${SALESAPI_URL}/api/ClubEntry/return-card`,
  CLUB_ENTRY_CONSUME_DAILY_RIGHT: `${SALESAPI_URL}/api/ClubEntry/consume-daily-right`,
  CLUB_ENTRY_MARK_DEPOSIT_REFUNDED: `${SALESAPI_URL}/api/ClubEntry/mark-deposit-refunded`,
  // Karta Tanımlı Ön Ödemeli Ürün Hakkı (Entitlement)
  CLUB_ENTRY_CARD_ENTITLEMENTS: (cardUID: string) => `${SALESAPI_URL}/api/ClubEntry/card-entitlements/${encodeURIComponent(cardUID)}`,
  CLUB_ENTRY_CONSUME_ENTITLEMENTS: `${SALESAPI_URL}/api/ClubEntry/consume-entitlements`,
  // Kulüp Girişi Paketleri (Club Entry Packages)
  CLUB_ENTRY_PACKAGES: (screenId: number) => `${SALESAPI_URL}/api/ClubEntry/packages/${screenId}`,
  CLUB_ENTRY_PACKAGE_CREATE: `${SALESAPI_URL}/api/ClubEntry/packages`,
  CLUB_ENTRY_PACKAGE_UPDATE: (id: number) => `${SALESAPI_URL}/api/ClubEntry/packages/${id}`,
  CLUB_ENTRY_PACKAGE_DELETE: (id: number) => `${SALESAPI_URL}/api/ClubEntry/packages/${id}`,
};

/**
 * API istek ayarları
 */
export const API_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
  },
};

// ========== E-INVOICE API ENDPOINTS ==========
export const EINVOICE_API = {
  // E-Fatura Entegrasyon Listesi (SQL - AccountingAPI)
  INTEGRATION_LIST: `${ACCOUNTINGAPI_URL}/api/accounting/EInvoiceIntegration/list`,
  
  // E-Fatura Kullanıcı Sorgulama (QNBESolutions)
  USER_QUERY: (username: string, password: string, vkn: string) => 
    `${process.env.REACT_APP_EINVOICE_URL}/QNBESolutions/EFaturaKullaniciBilgisi?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&sorguVkn=${encodeURIComponent(vkn)}`,
  
  // E-Fatura Gönderme
  SEND: `${ACCOUNTINGAPI_URL}/api/EInvoice/send`,
  
  // E-Fatura Durum Sorgulama
  STATUS: (invoiceId: string) => `${ACCOUNTINGAPI_URL}/api/EInvoice/status/${invoiceId}`,
  
  // E-Fatura XML Önizleme
  PREVIEW_XML: `${ACCOUNTINGAPI_URL}/api/EInvoice/preview-xml`,
  
  // E-Fatura İptal
  CANCEL: (invoiceId: string) => `${ACCOUNTINGAPI_URL}/api/EInvoice/cancel/${invoiceId}`,
  
  // E-Arşiv PDF İndirme
  DOWNLOAD_PDF: (invoiceId: string) => `${ACCOUNTINGAPI_URL}/api/EInvoice/download-pdf/${invoiceId}`,
  
  // ========== QNB E-SOLUTIONS ENDPOINTS ==========
  // Gelen Fatura Yanıt Gönderme (Kabul/Red)
  QNB_GELEN_FATURA_YANIT_GONDER: `${process.env.REACT_APP_EINVOICE_URL}/QNBESolutions/GelenFaturaYanitGonder`,
  
  // Fatura Tarihçe Sorgulama
  QNB_FATURA_TARIHCE_SORGULA: `${process.env.REACT_APP_EINVOICE_URL}/QNBESolutions/FaturaTarihceSorgulaExt`,

  // ========== YENİ gts_einvoice_api (EDM) ENDPOINTS ==========
  // einvoiceApi client ile çağrılır (sadece Bearer; X-Company-Id GÖNDERİLMEZ).
  EDM_TEST_CONNECTION: `${EINVOICE_API_URL}/api/einvoice/edm/test-connection`,
  EDM_ENVIRONMENT: `${EINVOICE_API_URL}/api/einvoice/edm/environment`,
  EDM_MUKELLEF_SORGULA: `${EINVOICE_API_URL}/api/einvoice/edm/mukellef-sorgula`,
  EDM_KONTOR_SORGULA: `${EINVOICE_API_URL}/api/einvoice/edm/kontor-sorgula`,
  EDM_SERIALS: `${EINVOICE_API_URL}/api/einvoice/edm/serials`,
  EDM_GB_ALIASES: `${EINVOICE_API_URL}/api/einvoice/edm/gb-aliases`,
  EDM_UBL_PREVIEW: `${EINVOICE_API_URL}/api/einvoice/edm/ubl-preview`,
  EDM_SEND: `${EINVOICE_API_URL}/api/einvoice/edm/send`,
  EDM_STATUS: `${EINVOICE_API_URL}/api/einvoice/edm/status`,
  EDM_HISTORY: `${EINVOICE_API_URL}/api/einvoice/edm/history`,
  EDM_DOCUMENT: `${EINVOICE_API_URL}/api/einvoice/edm/document`,
  EDM_DOCUMENT_DOWNLOAD: `${EINVOICE_API_URL}/api/einvoice/edm/document-download`,
  EDM_CANCEL: `${EINVOICE_API_URL}/api/einvoice/edm/cancel`,
  EDM_INBOX: `${EINVOICE_API_URL}/api/einvoice/edm/inbox`,
  EDM_INBOX_CONTENT: `${EINVOICE_API_URL}/api/einvoice/edm/inbox/content`,
  EDM_INBOX_RESPOND: `${EINVOICE_API_URL}/api/einvoice/edm/inbox/respond`,
  EDM_INBOX_STATUS: `${EINVOICE_API_URL}/api/einvoice/edm/inbox/status`,
  EDM_INBOX_MARK: `${EINVOICE_API_URL}/api/einvoice/edm/inbox/mark`,
};

/**
 * API hata mesajlarını işle
 */
export const handleApiError = (error: any): string => {
  if (error.response) {
    // Sunucu hata yanıtı — e-fatura API'si `error`/`errorShort` döner; diğerleri `message`.
    const data = error.response.data;
    if (typeof data === 'string' && data.trim()) return data;
    return (
      data?.errorShort ||
      data?.error ||
      data?.message ||
      data?.title ||
      'Bir hata oluştu'
    );
  } else if (error.request) {
    // İstek gönderildi ama yanıt alınamadı
    return 'Sunucuya bağlanılamadı';
  } else {
    // İstek oluşturulurken hata
    return error.message || 'Bilinmeyen bir hata oluştu';
  }
};
